import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowShareRight: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-share-right, next, forward"><path d="M22.25 12L12.75 3.75V8.5C4.25 8.5 1.75 11.75 1.75 20.25C3.25 17.25 4.25 15.5 12.75 15.5V20.25L22.25 12Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconArrowShareRight;
